import loadable from '@loadable/component';

import type { CmsApiRecommendedActionsBlockData } from 'modules/cms/api/types/blocks/CmsApiRecommendedActionsBlock';
import type { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

export const CmsRecommendedActionsBlockMapping: CmsBlockMapping<CmsApiRecommendedActionsBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: loadable(() => import('./CmsRecommendedActionsBlock'), {
      resolveComponent: (module) => module.CmsRecommendedActionsBlock,
    }),
  };
